"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = require("@emotion/react");

var _Flex = _interopRequireDefault(require("./Flex"));

var _FlexUnit = _interopRequireDefault(require("./FlexUnit"));

var _theme = require("../../theme/theme");

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Hold = function Hold(_ref) {
  var className = _ref.className,
      children = _ref.children,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? "div" : _ref$as,
      _ref$asUnit = _ref.asUnit,
      asUnit = _ref$asUnit === void 0 ? "div" : _ref$asUnit,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? "center" : _ref$align,
      _ref$justify = _ref.justify,
      justify = _ref$justify === void 0 ? "center" : _ref$justify;
  return (0, _react.jsx)(_react.ClassNames, null, function (_ref2) {
    var css = _ref2.css,
        cx = _ref2.cx;
    return (0, _react.jsx)(_Flex["default"], {
      as: as,
      align: align,
      justify: justify,
      space: "0",
      className: cx(className, css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n                flex-grow: 1;\n                flex-flow: row wrap;\n                flex-wrap: wrap;\n                min-height: 100%;\n                min-width: 100%;\n                height: 100%;\n                width: 100%;\n              "]))))
    }, (0, _react.jsx)(_FlexUnit["default"], {
      as: asUnit,
      grow: "0",
      shrink: "1"
    }, children));
  });
};

Hold.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired,
  as: _propTypes["default"].string,
  asUnit: _propTypes["default"].string,
  align: _propTypes["default"].oneOf(_theme.FLEX_ALIGN_TYPES),
  justify: _propTypes["default"].oneOf(_theme.FLEX_JUSTIFY_TYPES)
};
var _default = Hold;
exports["default"] = _default;